<script setup lang="ts">
import dayjs from 'dayjs';
import { onMounted, ref } from 'vue';
import tipoCompromissoEnum from '~/enums/tipoCompromissoEnum';
import { useDrawerStore } from '~/stores/drawer';
import { desabilitarDatasPraTras, isNilOrEmpty } from '~/utils';
import { useAuthStore } from '~/stores/auth';

const props = defineProps({
  compromisso: {
    required: true,
    type: Object,
  },
});

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const authStore = useAuthStore();
const drawerStore = useDrawerStore();

const tiposCompromissosQueTemAtalhos = ref([
  tipoCompromissoEnum.CaqGcpjDesatualizado,
]);

function uiSolicitarAtualizacaoGcpj()
{
  drawerStore.push2({
    componentName: 'CompromissoForm2',
    params: {
      componentName: 'SolicitarAtualizacaoGcpjForm',
      componentProps: {
        encaminharParaEquipeGcpj: true,
        pastaCodigos: [props.compromisso.fluxo.pastaCodigo],
      },
      title: 'SOLICITAR ATUALIZAÇÃO GCPJ',
    },
  });
}

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <CompromissoJobCommandForm
    command="CumprirCompromissoCaqCommand"
    :show-upload-files="true"
    :submit-button-disabled="!isNilOrEmpty(props.compromisso)
      && props.compromisso.responsavel.codigo !== authStore.codigoUsuario"
    :initial-model="{
      compromissoCodigos: [compromisso.codigo],
    }"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Escolha uma das opções abaixo"
        name="seraCumprido"
        :rules="[{
          message: 'É necessário informar se o compromisso será cumprido',
          required: true,
          type: 'boolean',
        }]"
      >
        <a-radio-group v-model:value="model.seraCumprido">
          <a-radio-button :value="true">
            Cumprir agora
          </a-radio-button>
          <a-radio-button :value="false">
            Reagendar
          </a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        v-if="model.seraCumprido === true"
        label="Observação"
        name="observacao"
        :rules="[{ message: 'Observação é obrigatória', required: true }]"
      >
        <a-textarea
          v-model:value="model.observacao"
          :rows="4"
        />
      </a-form-item>

      <a-form-item
        v-if="model.seraCumprido === false"
        label="Novo vencimento"
        name="novoVencimento"
        :rules="[{ message: 'Novo vencimento é obrigatório', required: true }]"
      >
        <a-date-picker
          v-model:value="model.novoVencimento"
          format="DD/MM/YYYY HH:mm"
          value-format="DD/MM/YYYY HH:mm"
          placeholder="Escolha a data de vencimento"
          :disabled-date="desabilitarDatasPraTras"
          :show-time="{ defaultValue: dayjs('17:00:00', 'HH:mm:ss') }"
          style="width: 300px"
        />
      </a-form-item>

      <a-form-item
        v-if="model.seraCumprido === false"
        label="Justificativa"
        name="justificativaParaNaoCumprimento"
        :rules="[{ message: 'Justificativa é obrigatória', required: true }]"
      >
        <a-textarea
          v-model:value="model.justificativaParaNaoCumprimento"
          :rows="4"
        />
      </a-form-item>

      <a-form-item
        v-if="
          tiposCompromissosQueTemAtalhos.indexOf(
            compromisso.tipoValue,
          ) >= 0
        "
        label="Atalhos"
      >
        <a-space>
          <a-button
            v-if="
              compromisso.tipoValue
                === tipoCompromissoEnum.CaqGcpjDesatualizado
            "
            @click="uiSolicitarAtualizacaoGcpj"
          >
            Atualizar GCPJ
          </a-button>
        </a-space>
      </a-form-item>
    </template>
  </CompromissoJobCommandForm>
</template>
